module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Angle-double-right-5590cf209f6fe0c5b24bc13a3fa55823.svg";